var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPending = function SvgPending(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 113,
    viewBox: "0 0 108 113",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h108v113H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74 111.5c0 .829-8.283 1.5-18.5 1.5s-18.5-.671-18.5-1.5c0-.828 8.283-1.5 18.5-1.5s18.5.672 18.5 1.5",
    fill: "#E9EFF3"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(30)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.962 44.217C40.362 42.133 49 32.209 49 20.282c0-4.433-1.193-8.59-3.278-12.17H3.278A24.103 24.103 0 0 0 0 20.283c0 11.927 8.637 21.851 20.038 23.935A19.22 19.22 0 0 1 20.417 48a19.22 19.22 0 0 1-.38 3.783C8.638 53.867 0 63.791 0 75.718c0 4.433 1.193 8.59 3.278 12.17h42.444A24.103 24.103 0 0 0 49 75.717c0-11.927-8.637-21.851-20.038-23.935A19.22 19.22 0 0 1 28.583 48c0-1.261.127-2.522.38-3.783Z",
    fill: "#DAEFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.782 85.184A20.426 20.426 0 0 1 24.5 73.014a20.426 20.426 0 0 1 18.718 12.17H5.782ZM43.218 28.394A20.426 20.426 0 0 1 24.5 40.564a20.426 20.426 0 0 1-18.718-12.17h37.436Z",
    fill: "#4EB7F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.247 39.211h8.506c-1.95 2.704-2.926 5.409-2.926 8.113 0 1.644.025 2.954.076 3.932a1.404 1.404 0 0 1-1.403 1.476 1.425 1.425 0 0 1-1.424-1.485c.042-.977.063-2.284.063-3.923 0-2.704-.964-5.409-2.892-8.113Z",
    fill: "#4EB7F5"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#A4D6FC",
    y: 87.887,
    width: 49,
    height: 8.113,
    rx: 4.056
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#A4D6FC",
    width: 49,
    height: 8.113,
    rx: 4.056
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#4EB7F5",
    cx: 24.5,
    cy: 55.437,
    rx: 1.361,
    ry: 1.352
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#4EB7F5",
    cx: 25.181,
    cy: 61.521,
    rx: 2.042,
    ry: 2.028
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#4EB7F5",
    cx: 24.5,
    cy: 74.366,
    rx: 2.722,
    ry: 2.704
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#4EB7F5",
    cx: 23.139,
    cy: 67.606,
    rx: 1.361,
    ry: 1.352
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.284 10.817a20.087 20.087 0 0 1 2.355 9.465c0 11.015-8.84 19.98-19.858 20.274 7.637-2.935 13.052-10.3 13.052-18.922 0-3.977-1.152-7.686-3.143-10.817h7.594ZM43.135 85.175a20.089 20.089 0 0 0 3.143-10.816c0-11.016-8.84-19.98-19.858-20.275 7.637 2.935 13.052 10.3 13.052 18.922 0 4.566-1.519 8.78-4.082 12.17h7.745Z",
    fill: "#FFF",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(64 76)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#CD68ED",
    cx: 14,
    cy: 14,
    r: 14
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M8.733 19.988h10.742v-1.567H8.733zM20.156 8.469h-1.531s.279 2.497-1.926 2.497-1.902-2.497-1.902-2.497h-1.531s.368 2.48-1.866 2.48-1.963-2.48-1.963-2.48h-1.53l.765 8.85H19.39l.765-8.85Z"
  })))));
};
export default SvgPending;